import { render, staticRenderFns } from "./VoxelPainter.vue?vue&type=template&id=46b9fa18&scoped=true&"
import script from "./VoxelPainter.vue?vue&type=script&lang=js&"
export * from "./VoxelPainter.vue?vue&type=script&lang=js&"
import style0 from "./VoxelPainter.vue?vue&type=style&index=0&id=46b9fa18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9fa18",
  null
  
)

export default component.exports